import { useMemo } from 'react';
import { useTranslation as useDefaultTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import meta from '../../package.json';

export function useTranslation(name: string = meta.name) {
  return useDefaultTranslation(name);
}

export function useActualLanguage() {
  const { i18n } = useDefaultTranslation();
  const actualFlag = useMemo(() => {
    let language = i18n.language;
    if (language.indexOf('-') > -1) {
      language = language.split('-')[0];
    }
    return language;
  }, [i18n.language]);
  return actualFlag;
}

export default useTranslation;
